import {
    FC,
    InputHTMLAttributes,
    ReactElement,
    RefAttributes,
} from 'react'
import classNames from 'classnames'

import { Checkbox } from '../../../compositions/GroupedCheckboxes'
import { FormOption } from '../../../types'
import Icon from '../../Icon/Icon'

import './Checkbox.scss'

export type HTMLInputProps = InputHTMLAttributes<HTMLInputElement> & RefAttributes<HTMLInputElement>;

interface GroupedCheckboxProps extends HTMLInputProps {
    option: FormOption;
    name: string;
    className?: string;
}

const GroupedCheckbox: FC<GroupedCheckboxProps> = ({
    checked = false,
    disabled = false,
    option,
    name,
    className = '',
    ...inputProps
}): ReactElement => {
    const checkboxClassNames = classNames('checkbox', {
        'checkbox--is-checked': checked,
        'checkbox--is-disabled': disabled,
    }, className)

    return (
        <label className={checkboxClassNames}>
            <Checkbox
                {...inputProps}
                id={option.label}
                name={name}
                value={option.value}
                checked={checked}
                disabled={disabled}
                className="checkbox__input"
            />

            <div className="checkbox__box">
                <Icon name="checkbox-check" className="checkbox__icon" />
            </div>

            <span className="checkbox__label">
                {option.label}
            </span>
        </label>
    )
}

export default GroupedCheckbox
